export const CHART_OPTIONS = {
    chart: {
        stacked: true,
        toolbar: {
            show: false,
        },
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    grid: {
        show: true,
    },
    legend: {
        show: true,
        horizontalAlign: 'center',
        position: 'top',
    },
    xaxis: {
        title: {
            text: 'Months',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title',
            },
        },
        categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ],
        labels: {
            style: {
                colors: Array.from({ length: 12 })?.map(()=> '#667085'),
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
            },
        },
    },
    yaxis: {
        title: {
            text: 'Total Patients',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title',
            },
        },
        labels: {
            formatter: (value) => {
                return value;
            },
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    colors: ['#AD509E', '#E9BEE3'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4,
        },
    },
};

export const CHART_SERIES = [
    {
        name: 'Actual',
        data: [44, 55, 41, 67, 22, 11, 17, 15, 15, 21, 13, 23],
    },
    {
        name: 'Predicted',
        data: [13, 23, 20, 8, 13, 21, 7, 25, 13, 22, 44, 55],
    },
];